import React, { useEffect, useState } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import _ from 'lodash';
import cx from 'classnames';

import { Urls } from 'constants/constants';
import { useDidMount, useUpdateEffect } from 'utils/components';


import { selectCurrentUser } from 'store/AppState';
import Stream, { selectRecentStreams } from 'store/models/Stream';
import { selectCurrentAccount, } from 'store/models/Account';
import Channel, { selectChannelsByIds, selectChannels } from 'store/models/Channel';
import { selectAllGames } from 'store/models/Game';
import { selectSessionsByStreamIds } from 'store/models/Session';
import { selectRecentStreamStats } from 'store/models/Stats';
import RouteState from 'store/RouteState';
import UIState, { addUIViewReducer } from 'store/UIState';

import { ContentCenter, Header, Title, Breadcrumbs } from 'components/Content';
import { EmptyItem } from 'components/EmptyItem';
import { StreamList } from 'components/StreamItem';
import ScrollToTop from 'components/ScrollToTop';
import ChannelSelect from 'components/ChannelSelect';


// ======================
// STORE
// ====================== 
const STREAMS_SELECT_CHANNEL = 'STREAMS_SELECT_CHANNEL';
addUIViewReducer('streamsScreen', (state, action) => {
  switch(action.type) {
    case STREAMS_SELECT_CHANNEL:
      return {
        ...state,
        channelId: action.channelId
      }
  }
  return state;
});
const selectChannelId = (state) => state.ui.views?.streamsScreen?.channelId ?? null;

const selectors = createSelector(
  selectCurrentUser,
  selectCurrentAccount,
  selectRecentStreams,
  (state) => selectRecentStreams(state) |> _.map(#, '_id') |> selectSessionsByStreamIds(state, #),
  selectRecentStreamStats,
  selectAllGames,
  (state) => selectRecentStreams(state) |> _.map(#, 'channelId') |> selectChannelsByIds(state, #),
  selectChannels,
  selectChannelId,
  (user, account, streams, sessions, stats, games, channels, allChannels, channelId) => ({ 
    user, 
    account,
    streams,
    sessions,
    stats,
    games,
    channels,
    allChannels,
    channelId
  })
)




// ======================
// COMPONENT
// ====================== 

const StreamsScreen = () => {
  const {streams, sessions, stats, channels, games, allChannels, channelId} = useSelector(selectors);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
   
  const fetchData = async () => await dispatch(Stream.actions.fetchRecentStreams(30, channelId))

  useEffect(() =>{
    (async () => {
      if(_.isEmpty(streams))
        setLoading(true);
      await fetchData();
      await Channel.actions.fetchChannels();
      setLoading(false);
    })();
  }, []);

  useUpdateEffect(() =>{
    (async () => {
      setLoading(true);
      await fetchData();
      setLoading(false);
    })();
  }, [channelId]);



  const onStreamClick = ({ _id: streamId }) => dispatch(RouteState.actions.navigate(Urls.STREAM_DETAILS_ROUTE, { streamId }))
  const onChannelChange = (channelId) => dispatch({ type: STREAMS_SELECT_CHANNEL, channelId });

  return (
    <ContentCenter className="account-settings">
      <ScrollToTop />
      <Header>
        <Title>Recent Streams</Title>
        <ChannelSelect 
          channels={allChannels} 
          size="m" 
          showAll={true}
          selected={channelId} 
          onChange={onChannelChange} />
      </Header>
      <StreamList channels={channels} streams={streams} stats={stats} games={games} showChannel={true} sessions={sessions} onStreamClick={onStreamClick} loading={loading} />
    </ContentCenter>);
}

export default StreamsScreen;
